import { setSortingValues } from 'feature/form/formSlice';
import {
	getFraudTracking,
	setFraudPage,
} from 'feature/fraudTracking/fraudTrackingSlice';
import { useDebounce } from 'hooks/debouncer.hook';
import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { buildFraudFilterParams } from 'utils/utils';
import FraudTrackingFooter from './FraudTrackingFooter.component';
import FraudTrackingTable from './FraudTrackingTable';

const ViewFraudTracking = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { page } = useSelector((store: RootState) => store.fraudTracking);
	const { sortingFields, sortingDirections } = useSelector(
		(store: RootState) => store.form,
	);
	const form = useSelector((store: RootState) => store.form);

	const { queryParams: searchParams } = buildFraudFilterParams(form);
	const searchParamsDeb = useDebounce(searchParams);

	useEffect(() => {
		dispatch(
			setSortingValues({
				name: 'fraudId,referralDate',
				value: 'DESC,DESC',
			}),
		);

		return () => {
			dispatch(setFraudPage(1));
		};
	}, [dispatch]);

	useEffect(() => {
		dispatch(getFraudTracking());
	}, [dispatch]);

	useEffect(() => {
		dispatch(setFraudPage(1));
		dispatch(getFraudTracking());
	}, [dispatch, searchParamsDeb, sortingFields, sortingDirections]);

	useEffect(() => {
		dispatch(getFraudTracking());
	}, [dispatch, page]);

	return (
		<Fragment>
			<FraudTrackingTable />
			<FraudTrackingFooter />
		</Fragment>
	);
};

export default ViewFraudTracking;
